export default "__VITE_ASSET__BH8iLPG8__"